// const SUBSCRIBEURL = 'http://localhost:5000/subscriber/';
// const USERURL = 'http://localhost:5001/users/';
// const FSERVICEURL = 'http://localhost:3001/';

// const ACCOUNTURL = 'http://localhost:5003/accounts/';

const SUBSCRIBEURL = 'https://subscriberservice.saassrs.com/subscriber/';
const USERURL = 'https://userservice.saassrs.com/users/';
const FSERVICEURL = 'https://servicepanel.srsinfoway.in/';
const ACCOUNTURL = 'https://accountservice.saassrs.com/accounts/';

// const CDASHBOARD = 'https://localhost:3003/panel/dashboard'

export {SUBSCRIBEURL,USERURL,FSERVICEURL,ACCOUNTURL}